import { createFileRoute, redirect } from "@tanstack/react-router";
import InsightArticle from "@/pages/InsightArticle";
import { articleHead, fetchArticleSsrMeta } from "@/lib/articleHead";

export const Route = createFileRoute("/en/guides/$slug")({
  // Slug inexistente => 301 permanente al listado. Antes se servía un 200
  // vacío y Google lo registraba como soft 404.
  loader: async ({ params }) => {
    const meta = await fetchArticleSsrMeta(params.slug, "en", "/guias", "/en/guides");
    if (!meta) throw redirect({ to: "/en/guides", statusCode: 301 });
    return meta;
  },
  head: ({ loaderData }) => articleHead(loaderData ?? null),
  component: InsightArticle,
});
